import { Component } from '@angular/core';

@Component({
  selector: 'vb-app-loader-animated',
  templateUrl: './app-loader-animated.component.html',
  styleUrls: ['./app-loader-animated.component.scss'],
  standalone: false  //NOSONAR
})
export class AppLoaderAnimatedComponent {}
